export const buyerNames: string[] = [
  'Michael T.',
  'Jessica R.',
  'David L.',
  'Ashley M.',
  'Christopher B.',
  'Amanda K.',
  'Daniel S.',
  'Brittany C.',
  'Matthew H.',
  'Samantha W.',
  'Joshua P.',
  'Megan D.',
  'Andrew G.',
  'Nicole F.',
  'Ryan V.',
  'Lauren A.',
  'Justin N.',
  'Rachel O.',
  'Brandon E.',
  'Stephanie J.',
  'Kevin Q.',
  'Melissa Z.',
  'Tyler U.',
  'Kayla I.',
  'Carlos M.',
  'Gabriela S.',
  'Luis A.',
  'Valeria T.',
  'Diego R.',
  'Camila P.'
]

export const usCities: string[] = [
  'Miami, FL',
  'Los Angeles, CA',
  'New York, NY',
  'Houston, TX',
  'Chicago, IL',
  'Phoenix, AZ',
  'San Antonio, TX',
  'Dallas, TX',
  'Orlando, FL',
  'Atlanta, GA',
  'Las Vegas, NV',
  'Denver, CO',
  'Seattle, WA',
  'San Diego, CA',
  'Charlotte, NC',
  'Austin, TX',
  'Tampa, FL',
  'Philadelphia, PA',
  'Boston, MA',
  'Nashville, TN',
  'Newark, NJ',
  'Sacramento, CA'
]
